import { AFRAME } from "../../react/root";
var THREE = window.THREE;
export default function () {
    AFRAME.registerComponent('flashing', {
        schema: {
            onColor: { default: 'red' },
            offColor: { default: '#FFF' }, // Default to white when not flashing
            duration: { default: 1000 } // Duration of one flash cycle in milliseconds
        },
        init: function () {
            var _a;
            this.el.setAttribute('material', 'color', ((_a = this === null || this === void 0 ? void 0 : this.data) === null || _a === void 0 ? void 0 : _a.offColor) || '#FFF');
            this.flash = this.flash.bind(this);
        },
        play: function () {
            this.flash();
        },
        pause: function () {
            this.el.removeAttribute('animation__color');
        },
        flash: function () {
            var el = this.el;
            var data = { duration: 1000, onColor: '#fff000', offColor: '#000' };
            // Animate to red
            el.setAttribute('animation__color', "property: material.color; to: ".concat((data === null || data === void 0 ? void 0 : data.onColor) || 'red', "; dur: ").concat(data.duration / 2, "; loop: false;"));
            // Wait for half duration, then animate back to original color
            setTimeout(function () {
                el.setAttribute('animation__color', "property: material.color; to: ".concat((data === null || data === void 0 ? void 0 : data.offColor) || '#FFF', "; dur: ").concat(data.duration / 2, "; loop: false;"));
            }, data.duration / 2);
            // Keep flashing
            setTimeout(this.flash, data.duration);
        }
    });
}
